import { Text } from '@lmn/design-system';
import { AirlineLogo, TransportLeg } from './summarySection.styles';

const getTime = (flightDate?: string) => flightDate?.split('#')?.[1] ?? '';

// A single flight leg, e.g. "LHR – PMI · Tue, 13 Aug (06:45 - 09:55)". Shared by
// the desktop sidebar (TransportSummarySection) and the mobile trip overview
// (MobileTransportSummary), where the legs sit stacked one per line.
export function TransportLegRow({ leg, day }: { leg: TransportBoundType; day: string }) {
  const segment = leg.segments?.[0];
  const company = segment?.company;
  return (
    <TransportLeg>
      <AirlineLogo
        code={company?.code}
        name={company?.name ?? ''}
        size={20}
        iconSize={20}
        transportType={segment?.type}
      />
      <Text variant="Body">
        {`${leg.origin} – ${leg.destination} · ${day} (${getTime(leg.departureDate)} - ${getTime(leg.arrivalDate)})`}
      </Text>
    </TransportLeg>
  );
}
